import { render, staticRenderFns } from "./EditSortDialog.vue?vue&type=template&id=f2039eb8&scoped=true"
import script from "./EditSortDialog.vue?vue&type=script&lang=js"
export * from "./EditSortDialog.vue?vue&type=script&lang=js"
import style0 from "./EditSortDialog.vue?vue&type=style&index=0&id=f2039eb8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_c2c4f8d10a02e12364bd9a7337709f82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2039eb8",
  null
  
)

export default component.exports